/** Removes the `st` marker after whitespace; returns an empty string for nullish input. i.e. Notodden st becomes Notodden. */
export const removeStationFromStopName = (
  stopName: string | undefined | null,
) => stopName?.replace(/\s+st(\s|\(|$)/, "$1") ?? "";

/** Removes a trailing parenthetical suffix from a station name i.e. Notodden st (kollektivterminal) becomes Notodden st. */
const shortenStationNames = (stationName: string) =>
  stationName.replace(/\s*\(.*\)$/, "");

/** Ultimate cleanup solution. i.e. Notodden st (kollektivterminal) becomes Notodden. */
export const trimStationName = (stopName: string | undefined | null) =>
  shortenStationNames(removeStationFromStopName(stopName));
